import { canMutate } from '@lib/types';
import { useAuthStore } from '@lib/store/auth.store';

/**
 * Hook utilitario: devuelve `false` si el usuario logueado es USER_MEDICUS
 * (rol de solo lectura). Las páginas y componentes lo usan para OCULTAR
 * botones que disparan mutaciones (validar/rechazar legajos, sincronizar
 * a HubSpot, disparar Renaper, descargar batch de altas, etc.). El
 * backend igual rechazaría con 403 por @Roles — esto es UX.
 *
 * Si todavía no hay sesión (login pendiente / rehidratación de zustand
 * en curso) devuelve `false` por seguridad: no mostramos el botón.
 */
export function useCanMutate(): boolean {
  const user = useAuthStore((s) => s.user);
  if (!user) return false;
  return canMutate(user.rol);
}
